<div class="option-container" [ngClass]="fill">
  <ion-icon class="option-image" [src]="iconPath"> </ion-icon>

  <div class="information">
    <span class="option-title">{{ capitalizeWords(tittle) }}</span>
    <span class="user-info">{{ info }}</span>
  </div>

  <button ion-button class="arrow-button">
    <ion-icon src="/assets/imgs/custom-svg/Icon akar-arrow-left.svg"></ion-icon>
  </button>
</div>